<template>
	<section class="content">
		<div class="error-page">
			<h2 class="headline text-warning">404</h2>
			<div class="error-content">
				<br>
				<h3><i class="fas fa-exclamation-triangle text-warning"></i> {{ title }}</h3>
				<p>{{ message }} <router-link to="/dashboard">{{ back }}</router-link></p>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'TheError404',
		data() {
			return {
				message: this.$t('labels.404message'),
				back: this.$t('labels.returnDashboard'),
				title: this.$t('labels.404title')
			}
		}
	}
</script>

<style></style>